<template>
    <transition name="fade" mode="out-in">
        <Spinner v-if="loading" />
        <div class="game-container" v-else>
            <div class="game" id="game">
                <!-- <p v-if="region=='bac'" style="color: red; line-height: 22px">Xổ số Miền Bắc sẽ nghỉ Tết nguyên đán 2022 từ ngày 29 tháng Chạp đến hết ngày mùng 3 tháng Giêng, tức từ ngày 31/01/2022 (dương lịch) đến hết ngày 03/02/2022 (dương lịch).<br>
                 Các bạn ghé thăm các xổ số miền Trung và Nam vào dịp Tết để có thể lấy lộc đầu năm nhé !</p> -->

                <div
                    class="game__top-wrapper d-flex w-100 justify-content-between"
                >
                    <div
                        class="game__date-picker d-flex w-50 align-items-center"
                    >
                    <div class="history__box-filter-date--wrap">
                        <span class="from-control__label">Ngày</span>
                        <label>
                            <InputDatepicker
                                :config="datepickerConfig"
                                v-model="selectedDate"
                                name="datepicker"
                                @onChange="onChangeDate"
                            />
                        </label>
                    </div>
                    </div>
                    <div
                        class="game__choose-channel d-flex w-50 justify-content-end justify-content-lg-center align-items-center"
                    >
                        <span class="from-control__label">Đài</span>
                        <label>
                            <Select
                                :options="cities"
                                v-model="selectedCity"
                                @change="changeCity"
                            />
                        </label>
                    </div>
                    <div
                        class="game__countdown d-none d-lg-flex justify-content-end align-items-center"
                    >
                        <div class="game__countdown-title mr-4">
                            Giờ xổ số
                        </div>
                        <div class="game__countdown-content">
                            <vue-countdown
                                :time="timeCountdown"
                                v-slot="{ hours, minutes, seconds }"
                            >
                                <span>
                                    {{ hours.toString().padStart(2, '0') }}
                                </span>
                                :
                                <span>
                                    {{ minutes.toString().padStart(2, '0') }}
                                </span>
                                :
                                <span>
                                    {{ seconds.toString().padStart(2, '0') }}
                                </span>
                            </vue-countdown>
                        </div>
                    </div>
                </div>
                <div class="game__channel d-flex justify-content-between">
                    <div
                        v-if="channelLogoJson[this.selectedCity.id]"
                        class="game__channel-logo d-flex align-items-center w-50"
                    >
                        <div class="game__channel-logo-box mr-2">
                            <picture
                                class="game__channel-logo-icon d-inline-block"
                            >
                                <source
                                    :srcset="
                                        require('@/assets/images/channel-logo/' +
                                            getCityLogo() +
                                            '.webp')
                                    "
                                    type="image/webp"
                                />
                                <img
                                    :src="
                                        require('@/assets/images/channel-logo/' +
                                            getCityLogo() +
                                            '.png')
                                    "
                                    :alt="getCityLogo()"
                                />
                            </picture>
                        </div>

                        <div class="game__channel-name font-weight-bold">
                            {{ selectedCity.name }}
                        </div>
                    </div>
                    <div
                        class="game__countdown d-lg-none w-50 justify-content-end align-items-center d-flex"
                    >
                        <div class="game__countdown-title mr-2">
                            Giờ xổ số
                        </div>
                        <div class="game__countdown-content">
                            <vue-countdown
                                :time="timeCountdown"
                                v-slot="{ hours, minutes, seconds }"
                            >
                                <span>
                                    {{ hours.toString().padStart(2, '0') }}
                                </span>
                                :
                                <span>
                                    {{ minutes.toString().padStart(2, '0') }}
                                </span>
                                :
                                <span>
                                    {{ seconds.toString().padStart(2, '0') }}
                                </span>
                            </vue-countdown>
                        </div>
                    </div>
                </div>
                <div class="game__games-wrapper">
                    <tabs
                        v-if="categories.length > 0"
                        cache-lifetime="0"
                        class="game__categories"
                        :options="{
                            useUrlFragment: false,
                            defaultTabHash: defaultTab,
                        }"
                        @changed="tabChanged"
                    >
                        <tab
                            class="game__tab d-none"
                            v-for="item in categories"
                            :key="item.type"
                            :id="item.type"
                            :name="item.name"
                            v-bind="{ tabData: item }"
                        >
                        </tab>
                    </tabs>
                    <div class="game__tab-wrapper">
                        <GameChild
                            @changeTab="onChildChanged"
                            v-bind="{
                                children: currentTabGame.children,
                                defaultTab: defaultChildTab,
                                rates,
                            }"
                            v-model="activeMethod"
                        />
                    </div>
                </div>
            </div>

            <Ticket
                :default-amount-one="
                    this.reBet && this.reBet.amount_one
                        ? this.reBet.amount_one / clientBalanceUnit
                        : 1
                "
                :is-show-additional-ticket="isShowAdditionalTicket"
            />
        </div>
    </transition>
</template>

<script>
import categoriesService from '@common/services/categories.service';
import citiesService from '@common/services/cities.service';
import InputDatepicker from '@/components/common/InputDatepicker/InputDatepicker';
import Select from '@/components/common/Select/Select';
import Ticket from '@/components/common/Ticket/Ticket';
import timeMixin from '@/mixins/time.mixin';
import { mapActions, mapGetters } from 'vuex';
import channelLogoJson from '@/assets/common/json/channel-logo.json';
import GameChild from '@/components/Game/Games/GameChild/GameChild';
import Spinner from '@/components/common/Spinner/Spinner';
import * as playingMethods from '@/utils/playingMethods';

const moment = require('moment');
const debounce = require('debounce');

export default {
    components: {
        GameChild,
        Select,
        InputDatepicker,
        Ticket,
        Spinner,
    },
    mixins: [timeMixin],
    data() {
        return {
            categories: [],
            cities: [],
            datepickerConfig: {
                dateFormat: 'd-m-Y',
            },
            timeCountdown: 0,
            isRendered: false,
            selectedNumber: [],
            selectedCity: {},
            selectedDate: null,
            defaultTab: this.reBet?.category?.type,
            defaultChildTab: null,
            channelLogoJson: channelLogoJson,
            clientBalanceUnit: process.env.VUE_APP_CLIENT_BALANCE_UNIT,
            isFirstLoadReBet: this.reBet && Object.keys(this.reBet).length > 0,
            loading: true,
            currentTabGame: {},
            activeMethod: playingMethods.CHOOSE_METHOD_ID,
        };
    },
    props: {
        reBet: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        region: String,
    },
    methods: {
        ...mapActions({
            fetchStartDate: 'userModule/fetchStartDate',
            setBetDataByKey: 'betModule/setBetDataByKey',
            fetchUserHistory: 'userModule/fetchUserHistory',
            fetchRates: 'betModule/fetchRates',
        }),
        getCategories: async region => {
            const {
                data: { rows: categories },
            } = await categoriesService.getCategories(region);
            return categories;
        },
        getCities: async (date, region) => {
            const {
                data: { rows: cities },
            } = await citiesService.getCities(date, region);
            return cities;
        },
        onChildChanged: debounce(function(val) {
            this.setCurrentGameToStore(val);
            if (!this.isFirstLoadReBet) {
                this.resetStoredNumber();
            }
            this.isFirstLoadReBet = false;
        }),
        tabChanged(selectedTab) {
            this.currentTabGame = selectedTab.tab.$attrs.tabData;
            this.setDefaultChildTab();
        },
        setCurrentGameToStore(gameData) {
            this.$store.dispatch('betModule/setBetDataByKey', {
                key: 'currentGame',
                value: gameData,
            });
        },
        setCurrentCity(city) {
            this.$store.dispatch('betModule/setBetDataByKey', {
                key: 'currentCity',
                value: city,
            });
        },
        setDatepickerOptions(date) {
            const currentDate = new Date(moment(date, 'DD-MM-YYYY'));

            return {
                dateFormat: 'd-m-Y',
                enable: [
                    function(date) {
                         return date >= currentDate;
                    },
                ],
            };
        },
        getRelease: async (id, date) => {
            const {
                data: { rows: currentCity },
            } = await citiesService.getRelease(id, date);
            return currentCity;
           
        },
        changeCity: async function() {
            const currentCity = await this.getRelease(
                this.selectedCity.id,
                this.selectedDate,
            );
            this.setCurrentCity(currentCity);
            this.selectedCity = currentCity;
            this.timeCountdown = this.milliseconds(
                this.selectedCity.second_left,
            );
        },
        onChangeDate: async function() {
            // Load city
            if (this.isRendered) {
                this.cities = await this.getCities(
                    this.selectedDate,
                    this.region,
                );
                await this.setDefaultCity();
            }
        },
        getCityLogo() {
            const cityId = this.selectedCity.id;
            return this.channelLogoJson[cityId]
                ? this.channelLogoJson[cityId].logo
                : 'not_found';
        },
        setDefaultCity: async function() {
            // Default city
            this.selectedCity =
                this.cities.find(e => e.id === Number(this.reBet.city_id)) ||
                this.cities[0];
            const currentCity = await this.getRelease(
                this.selectedCity.id,
                this.selectedDate,
            );
            this.setCurrentCity(currentCity);
        },
        setDefaultNumbers() {
            if (this.reBet) {
                let numbers = [];
                if (this.reBet.numbers) {
                    numbers = this.reBet?.numbers?.split('-').map(e => +e);
                }
                this.setBetDataByKey({
                    key: 'numbers',
                    value: numbers,
                });
            }
        },
        resetStoredNumber() {
            if (!this.isFirstLoadReBet) {
                this.setBetDataByKey({
                    key: 'numbers',
                    value: [],
                });
            }
        },
        setDefaultChildTab() {
            this.defaultChildTab =
                this.isFirstLoadReBet && this.reBet?.category?.code
                    ? this.reBet?.category?.code
                    : this.currentTabGame.children[0].code;
        },
        setDefaultCurrentGame() {
            if (this.reBet && this.reBet.category) {
                this.currentTabGame = this.categories.find(cate => {
                    const childGame = cate.children.find(child => {
                        return child.id === this.reBet.category.id;
                    });
                    return !!childGame;
                });
            } else {
                this.currentTabGame = this.categories[0];
            }
        },
        setDefaultDate() {
            this.selectedDate =
                this.reBet && this.reBet.date
                    ? this.reBet.date
                    : this.currentDate;
        },
    },
    async created() {
        this.loading = true;
        await this.fetchStartDate();
        this.setDefaultNumbers();
        this.setDefaultDate();
        this.datepickerConfig = this.setDatepickerOptions(this.currentDate);
        this.categories = await this.getCategories(this.region);
        this.setDefaultCurrentGame();

        // City
        this.cities = await this.getCities(this.selectedDate, this.region);
        await this.setDefaultCity();

        // Countdown
        this.timeCountdown = this.milliseconds(this.selectedCity.second_left);
        // Get rates
        await this.fetchRates();

        this.isRendered = true;

        // Get history
        this.fetchUserHistory().then();

        this.loading = false;
    },
    computed: {
        ...mapGetters({
            currentDate: 'userModule/startDate',
            rates: 'betModule/rates',
        }),
        isShowAdditionalTicket() {
            return this.activeMethod === playingMethods.CHOOSE_METHOD_ID;
        },
    },
    watch: {
        selectedDate: function(v) {
            // Change date
            this.setBetDataByKey({ key: 'date', value: v });
        },
    },
};
</script>

<style scoped lang="scss">
@import 'Game';
</style>
